import React from 'react';
import PropTypes from 'prop-types';

class Currency extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      unit: ['rub', 'eur'].find((unit) => unit === this.props.unit) || 'rub',
    };
  }

  render() {
    switch (this.state.unit) {
      case 'eur':
        break;
      default:
        return <span>{this.props.value ? this.props.value.toLocaleString() : ''} ₽</span>;
    }
  }
}

Currency.propTypes = { unit: PropTypes.oneOf(['rub', 'eur']), value: PropTypes.number };

export default Currency;
